/* eslint-disable */
import api from '@/services/api';
import { format } from 'date-fns';

export default {
  async fetchInformacoesCambio({ dispatch, commit }, payload) {
    dispatch('toggleLoading', true, { root: true });
    try {
      const { periodo, page, perPage, termo } = payload;
      const params = new URLSearchParams();

      if (periodo && periodo[0]) {
        const dataInicial = format(new Date(periodo[0]), 'yyyy-MM-dd');
        params.append('dataInicial', dataInicial);
      }

      if (periodo && periodo[1]) {
        const dataFinal = format(new Date(periodo[1]), 'yyyy-MM-dd');
        params.append('dataFinal', dataFinal);
      }

      if (termo) {
        params.append('termo', termo);
      }

      params.append('perPage', perPage);
      params.append('page', page);

      const response = await api.get('/processo/cambio/', { params });

      commit('UPDATE_CAMBIO_STATE', response.data.registros.data);
      commit('paginacao/SET_PAGINADOR', response.data.registros, { root: true });
    } catch (err) {
      dispatch(
        'setGlobalError',
        'Não foi possível recuperar as informações do câmbio',
        { root: true },
      );
    }

    dispatch('toggleLoading', false, { root: true });
  },
  async filtrar({ commit, dispatch }, payload) {
    commit('SET_FILTROS', payload);
    dispatch('fetchInformacoesCambio', payload);
  },
  async fetchSingleCambio({ dispatch, commit }, payload) {
    const { codigoProcesso, codigoFilial } = payload;
    dispatch('toggleLoading', true, { root: true });
    try {
      const response = await api.get(`/processo/cambio/${codigoProcesso}/filial/${codigoFilial}`);
      commit('UPDATE_SELECTED_CAMBIO', response.data.registros);
      dispatch('toggleLoading', false, { root: true });
    } catch (err) {
      dispatch(
        'setGlobalError',
        'Não foi possível recuperar as informações do câmbio',
        { root: true },
      );
    }
  },
  updateColunasDisponiveis({ commit }, payload) {
    commit('UPDATE_COLUNAS_DISPONIVEIS', payload);
  },
  setColunasDinamicas({ commit }, payload) {
    commit('SET_COLUNAS_DINAMICAS', payload);
  },
};
